class SupportController {
  private models: {
    authentication: any;
    configuration: any;
    responseFailure: any;
  };
  private links: {
    feedback: string;
    support: string;
  };
  private techHelp: {
    description: string;
    details: any;
    footer: string;
    nk: string;
    title: string;
  };
  private hasTechHelpDetails: boolean;
  constructor(
    private $state: ng.ui.IStateService,
    private accountModel: any,
    private appConfigModel: any,
    private ngAuthenticationQueryModel: any,
    private authenticationConfiguration: any
  ) {}
  $onInit() {
    const adviceLocation: string = this.$state.params.adviceLocation;
    const responseFailure = JSON.parse(sessionStorage.getItem(adviceLocation) as string);
    this.models = {
      authentication: this.ngAuthenticationQueryModel.read(),
      configuration: this.authenticationConfiguration.read(),
      responseFailure
    };

    const trackingId = !!this.models.authentication.identity.tracking_id
      ? this.models.authentication.identity.tracking_id
      : 'no-user-logged-in';

    this.links = {
      feedback: `mailto:feedback@eabse.zendesk.com?subject=User%20Feedback&body=< Please type your feedback here >%0A%0A%0A%0A%0A%0A%0A%0A%0A%0A** Reference# ${trackingId}`,
      support: `mailto:support@eabse.zendesk.com?subject=User%20Support&body=< Please type your message here >%0A%0A%0A%0A%0A%0A%0A%0A%0A%0A** Reference# ${trackingId}`
    };
    this.techHelp = this.appConfigModel.model.TECHNICAL_HELP;
    this.hasTechHelpDetails = !_.isEmpty(this.techHelp.details);
  }
  hasServerExplanation() {
    return this.models.responseFailure && this.models.responseFailure.data;
  }
  goBack() {
    history.back();
  }
}

angular.module('capability-ng-authentication').component('supportPage', {
  templateUrl: 'capability-ng-authentication/src/views/support/support.html',
  controller: SupportController,
  controllerAs: '$ctrl',
  bindings: {
    techHelpDetails: '<'
  }
});



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-authentication/src/views/support/support.ts